import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Loader2, TrendingUp, AlertTriangle, CheckCircle2, Clock } from "lucide-react";

export default function MobileReports() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/reports/team360")
      .then(r => setData(r.data?.data || {}))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center pt-16"><Loader2 className="animate-spin text-slate-400" /></div>;
  if (!data) return null;

  const cards = [
    { label: "Total Tasks", value: data.total_tasks ?? 0, color: "text-slate-900", bg: "bg-slate-50" },
    { label: "Open", value: data.open_tasks ?? 0, color: "text-[#334E7B]", bg: "bg-blue-50" },
    { label: "Completed", value: data.closed_tasks ?? 0, color: "text-emerald-700", bg: "bg-emerald-50" },
    { label: "Overdue", value: data.overdue_tasks ?? 0, color: "text-red-700", bg: "bg-red-50" },
    { label: "Approval Pending", value: data.approval_pending ?? 0, color: "text-violet-700", bg: "bg-violet-50" },
    { label: "Return Pending", value: data.return_pending ?? 0, color: "text-amber-700", bg: "bg-amber-50" },
    { label: "On-Time %", value: `${data.on_time_percentage ?? 0}%`, color: "text-emerald-700", bg: "bg-emerald-50" },
    { label: "Delay %", value: `${data.delay_percentage ?? 0}%`, color: "text-red-700", bg: "bg-red-50" },
  ];

  return (
    <div className="px-4 pt-4 pb-6">
      <div className="text-lg font-heading font-bold text-slate-900 mb-1">Executive Summary</div>
      <div className="text-xs text-slate-400 mb-5">Full reports available on desktop</div>

      <div className="grid grid-cols-2 gap-3">
        {cards.map(({ label, value, color, bg }) => (
          <div key={label} className={`${bg} rounded-2xl p-4 border border-white/50`}>
            <div className={`text-2xl font-heading font-bold ${color}`}>{value}</div>
            <div className="text-xs text-slate-500 font-medium mt-1">{label}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-amber-50 border border-amber-200 rounded-2xl p-4">
        <div className="text-sm font-semibold text-amber-800 mb-1">Full Reports on Desktop</div>
        <div className="text-xs text-amber-700">Detailed team, department, SLA breach, approval aging and WhatsApp reports are available on the desktop/tablet view.</div>
      </div>
    </div>
  );
}
